import React from "react";
import { Table } from "antd";

const RenderTable = ({ columns, data, loading }) => (
  <Table
    columns={columns}
    dataSource={data}
    loading={loading}
    rowKey="id"
    bordered
    pagination={{ pageSize: 10 }}
  />
);

export default RenderTable;
